import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfigService } from "@master/core/dist/core";
import { Observable } from "rxjs";
import { config } from "@config/config";
import { BaseService } from "./base.service";

@Injectable({
  providedIn: "root",
})
export class GenerateTransportService extends BaseService {
  constructor(
    private http: HttpClient,
    public appConfigService: AppConfigService
  ) {
    super(appConfigService);
  }

  generateTransportNumber(
    orderNumber: string,
    TDLNR:string

  ): Observable<any> {
    const url =  this.getUrl() +"/ws-samca/generate-transport-data";
    const data = {
      Pedido: orderNumber,
      Transportista: TDLNR
    };
    return this.http.post(url, data, {
      headers: new HttpHeaders().set("Content-Type", "application/json"),
    });
  }
}
